module.exports = __webpack_public_path__ + "img/replySmileHappy.89fa9a44.png";